import { render, staticRenderFns } from "./tcList.vue?vue&type=template&id=21318692&"
import script from "./tcList.vue?vue&type=script&lang=js&"
export * from "./tcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports